const constants = {
    USER_ACCESS_TOKEN_KEY: 'user_access_token',
    DD_MM_YY: 'DD/MM/YY',
    DD_MM_YYYY: 'DD/MM/YYYY',
    USER: 'USER',
    ROLE: 'ROLE',
    NATA_ROLE_AR: 'AR',
    NATA_ROLE_TA: 'TA',
    NATA_ROLE_CM: 'CM',
    NATA_ROLE_LA: 'LA',
    NATA_ROLE_ADMIN: 'SYSADMIN',
    CURRENT_ROLE : 'CURRENT_ROLE',
    MAX_UPLOAD_SIZE: 150000,
    REMEMBER_ME_FOR_DAYS: 15,
    NICE_MAX_UPLOAD_SIZE: '150MB',
    TIMEZONE: 'Australia/Sydney',
    FILE_EXISTS: "A document by this name has already been submitted. \
        You cannot modify documents once uploaded. \
        Please rename document and try again",
    NATA_CONTACTS: {
      PHONE: "1800 621 666 (free call)",
      PHONE_LINK: "1800621666",
      EMAIL: "portalsupport@nata.com.au",
      ADDRESS: "7 Leeds St, Rhodes NSW 2138",
      ADDRESS_LINK: "https://www.google.com/maps/search/?api=1&query=7+Leeds+St,+Rhodes+NSW+2138",
      WEBSITE: "www.nata.com.au",
      WEBSITE_LINK: "https://www.nata.com.au"
    },
    USER_ROLES :[
      {
        name:'SYSADMIN',
        fullName : 'System Admin'
      },
      {
        name : "AR",
        fullName : "Authorised Representative"
      },
      {
        name : "TA",
        fullName : "Technical Assessor"
      },
      {
        name : "CM",
        fullName : "Committee Member"
      }
    ],
    USER_STATES: [
      {
        label: "NSW",
        value: "NSW"
      },
      {
        label: "VIC",
        value: "VIC"
      },
      {
        label: "ACT",
        value: "ACT"
      },
      {
        label: "QLD",
        value: "QLD"
      },
      {
        label: "WA",
        value: "WA"
      },
      {
        label: "SA",
        value: "SA"
      },
      {
        label: "TAS",
        value: "TAS"
      },
      {
        label: "Other",
        value: "Other"
      }
    ],
    SUBSCRIPTION_CATEGORIES: {
      GENERAL: "General",
      ACCREDITATION: "Accreditation Program Updates",
      PUBLICATIONS: "Portal Publications",
      NEWSLETTERS: "NATA Newsletters"
    }
};

export default constants;
